import React, { useState } from "react";
import { Card, FieldGroup, Flex, SupTitle, Title, ValueBox } from "./style";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateVehiclePrice } from "../../services/balance";
import toast from "react-hot-toast";

const carClassMap = {
  VIP: "VIP",
  NORMAL: "عادي",
  BUS_7_SEATS: "باص أبو 7 راكب",
  BUS_15_SEATS: "باص أبو 15 راكب",
  BUS_30_SEATS: "باص أبو 30 راكب",
  BUS_50_SEATS: "باص أبو 50 راكب",
};

const VehicleCard = ({ type, pricePerKm, profitPercent, pricePerHour }) => {
  const translatedType = carClassMap[type] || "نوع غير معروف";

    const initialProfit = typeof profitPercent === "string" 
    ? parseFloat(profitPercent.replace("%", "")) / 100
    : profitPercent;

  const [edit, setEdit] = useState({
    price_per_distance: pricePerKm,
    price_per_hour: pricePerHour,
    profit_rate: initialProfit,
  });

  const qc = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data) => {
      let profit = data.profit_rate;
      if (typeof profit === "string") profit = parseFloat(profit);
      if (profit > 1) profit = profit / 100;

      const updatedData = {
        price_per_distance: data.price_per_distance,
        profit_rate: profit,
      };

      if (edit.price_per_hour !== undefined) {
        updatedData.price_per_hour =
          data.price_per_hour !== undefined
            ? data.price_per_hour
            : edit.price_per_hour;
      }

      return updateVehiclePrice(type, updatedData);
    },

    onSuccess: () => {
      toast.success("✅ تم الحفظ");
      qc.invalidateQueries(["prices"]);
    },

    onError: (error) => {
      toast.error("❌ فشل الحفظ");
    },
  });

  const handleBlur = () => {
    mutation.mutate(edit);
  };

  return (
    <Card>
      <Title>{translatedType}</Title>
      <Flex>
        <FieldGroup>
          <SupTitle>سعر الكم</SupTitle>
          <ValueBox
            $loading={mutation.isLoading}
            value={edit.price_per_distance}
            onChange={(e) =>
              setEdit({ ...edit, price_per_distance: +e.target.value })
            }
            onBlur={handleBlur}
          />
        </FieldGroup>
        {type.includes("BUS") && (
          <FieldGroup>
            <SupTitle>سعر الساعة</SupTitle>
            <ValueBox
              $loading={mutation.isLoading}
              value={edit.price_per_hour}
              onChange={(e) =>
                setEdit({ ...edit, price_per_hour: +e.target.value })
              }
              onBlur={handleBlur}
            />
          </FieldGroup>
        )}
      </Flex>
      <FieldGroup>
        <SupTitle>نسبة الربح</SupTitle>
        <ValueBox
          $loading={mutation.isLoading}
          value={edit.profit_rate*100}
          onChange={(e) => setEdit({ ...edit, profit_rate: +e.target.value /100})}
          onBlur={handleBlur}
        />
      </FieldGroup>
    </Card>
  );
};

export default VehicleCard;
